import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';

import { trackEvent } from 'dibs-tracking';

import styles from './ContemporaryLandingHeroMakerRowItem.scss';

const trackClick = () => {
    trackEvent({
        action: 'Featured Sellers',
        category: 'contemporary landing page interaction',
        label: 'featured maker clicked',
    });
};

export const ContemporaryLandingHeroMakerRowItem = ({ item }) => {
    if (!item) {
        return null;
    }

    return (
        <div className="colXs12 colLg4">
            <div className={styles.hero}>
                <div className={styles.tile}>
                    <a href={item.url} className={styles.link} onClick={trackClick}>
                        {item.bgImagePath ? (
                            <img
                                className={styles.backgroundImage}
                                src={item.bgImagePath}
                                alt={item.name}
                            />
                        ) : (
                            <div className={styles.backgroundPlaceholder} />
                        )}
                    </a>
                    <a href={item.url}>
                        <div className={styles.makerWrapper}>
                            <div className={styles.maker}>
                                <div className={styles.imageWrapper}>
                                    {item.userImagePath ? (
                                        <img
                                            className={styles.image}
                                            src={item.userImagePath}
                                            alt={item.name}
                                        />
                                    ) : (
                                        <div className={styles.imagePlaceholder} />
                                    )}
                                </div>
                                <p className={styles.label}>
                                    <FormattedMessage
                                        id="contemporaryLanding.heroMaker.featuredMaker"
                                        defaultMessage="Featured Maker"
                                    />
                                </p>
                                <p className={styles.name}>{item.name}</p>
                                <p className={styles.location}>{item.location}</p>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    );
};

ContemporaryLandingHeroMakerRowItem.propTypes = {
    items: PropTypes.array,
};
